import { useState, useContext } from "react";
import { IoIosArrowForward } from "react-icons/io";
import "./common.scss";
import { currentFormattedDateAndTime, trackEvent } from "../../utils/mixPanel";
import FormRendererContext from "../../services/context/FormRendererContext";

const OptionSelector = ({ data, setOption }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const { isJourneyReadOnly } = useContext(FormRendererContext);
  
  return (
    <>
      {data.label && <div>{data.label}</div>}
      {data.values && data.values.length ? (
        <>
          <form>
            {data.values.map((item) => {
              return (
                <div
                  className="radio-common my-3"
                  onClick={() => {
                    if (!isJourneyReadOnly && !data?.disabled) {
                      setSelectedOption(item.id);
                      setOption(item.id);
                      trackEvent(`option-selector ${data?.label} clicked`, {
                        question: data?.label,
                        questionKey: data?.key,
                        clickedAt: currentFormattedDateAndTime(),
                        // selectedValue: item.label
                        data: "Answered"
                      })
                    }
                  }}
                  style={
                    isJourneyReadOnly || data?.disabled
                      ? { opacity: 0.6, cursor: "not-allowed" }
                      : {}
                  }
                >
                  <div className="mr-2 flex justify-between text-field text-input w-full px-w py-3 cursor_pointer option_selector">
                    <span className="self-center">{item.label}</span>
                    <IoIosArrowForward className="self-center" />
                  </div>
                </div>
              );
            })}
          </form>
        </>
      ) : (
        <div></div>
      )}
    </>
  );
};
export default OptionSelector;
